<script setup>
import { shared } from './shared.js'
</script>

<template>
    <!-- Hosts modal -->
    <div class="modal modal-xl fade" id="hostsModal" tabindex="-1">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <h1 class="modal-title fs-5">Host devices</h1>
                    <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
                </div>
                <div class="modal-body">
                    <div v-if="hosts.length > 0">
                        <div class="form-check form-check-inline">
                            <input class="form-check-input" type="checkbox" id="show_only_online" v-model="show_only_online">
                            <label class="form-check-label" for="show_only_online">Only show online</label>
                        </div>
                    </div>
                    <table class="table table-hover align-middle" v-if="hosts.length > 0">
                        <thead>
                            <tr>
                                <th style="width: 200px;">Hostname</th>
                                <th>Nickname</th>
                                <th style="width: 100px;">Version</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(host, index) in hosts" :key="index"
                                v-show="((hostDetailsIndex == -1 && (host.status == 'online' || !show_only_online)) || hostDetail.hostname == host.hostname)"
                                :class="[(host.status == 'online') ? 'table-success' : 'table-secondary']"
                                >
                                <td v-on:click="showDetails(index)">
                                    <span class="fw-bold font-monospace">{{ host.hostname }}</span>
                                </td>
                                <td v-on:click="showDetails(index)">
                                    <span class="fst-italic"
                                        v-if="host.info && host.info.nickname && (host.info.nickname != host.hostname)">{{
                host.info.nickname }}</span>
                                </td>
                                <td v-on:click="showDetails(index)" class="text-end">
                                    <small v-if="host.info && host.info.client_version"><span style="width:80px;" class="badge rounded-pill text-bg-dark">{{ host.info.client_version }}</span></small>
                                </td>
                                <td width="70px" v-if="hostDetailsIndex >= 0">
                                    <button type="button" class="btn btn-info btn-sm" v-on:click="showDetails(-1)">Back</button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <div class="alert alert-info" role="alert" v-else>
                        Nothing to show here yet, try connecting to receive data...
                    </div>
                    <div v-if="hostDetailsIndex >= 0" class="row">
                        <hr/>
                        <div class="col-sm-6">
                            <ul class="nav nav-tabs">
                                <li class="nav-item">
                                    <button class="nav-link active" data-bs-toggle="tab" data-bs-target="#host-info"
                                        type="button">Info</button>
                                </li>
                                <li class="nav-item">
                                    <button class="nav-link" data-bs-toggle="tab" data-bs-target="#host-config"
                                        type="button">Config</button>
                                </li>
                                <li class="nav-item">
                                    <button class="nav-link" data-bs-toggle="tab" data-bs-target="#host-commissioning"
                                        type="button">Update and commissioning</button>
                                </li>
                            </ul>
                            <br>
                            <div class="tab-content">
                                <div class="tab-pane show active" id="host-info">
                                    <div>
                                        <button type="button" class="btn btn-warning btn-sm" @click="restartHost()">
                                            Restart host
                                        </button>
                                        <button type="button" class="btn btn-danger btn-sm float-end" data-bs-toggle="modal" data-bs-target="#confirmHostDeletionModal">
                                            Forget host
                                        </button>
                                    </div>
                                    <br/>
                                    <Vue3JsonEditor
                                        class="json-host-info"
                                        v-model="hostDetail.info"
                                        :show-btns="false"
                                        :mode="'view'"
                                        :expandedOnStart="true"/>
                                </div>
                                <div class="tab-pane show" id="host-config">
                                    <div>
                                        <button type="button" class="btn btn-primary btn-sm" style="margin-right: 10px;"
                                            @click="readHostConfig()">
                                            Read
                                        </button>
                                        <button type="button" class="btn btn-danger btn-sm" style="margin-right: 10px;"
                                            @click="updateHostConfig()">
                                            Write
                                        </button>
                                        <button type="button" class="btn btn-warning btn-sm" @click="restartHost()">
                                            Restart host
                                        </button>
                                    </div>
                                    <br/>
                                    <Vue3JsonEditor
                                        class="json-host-config"
                                        v-model="hostDetail.config"
                                        :show-btns="false"
                                        :mode="'form'"
                                        :expandedOnStart="true"
                                        @json-change="onJsonChange"/>
                                </div>
                                <div class="tab-pane show" id="host-commissioning">
                                    <div>
                                        <div class="input-group input-group-sm mb-3">
                                            <div class="input-group-text" style="width: 150px;">Slave count</div>
                                            <input type="text" class="form-control" v-model="commissioning_config.slave_count">
                                        </div>
                                        <div class="input-group input-group-sm mb-3">
                                            <div class="input-group-text" style="width: 150px;">System type</div>
                                            <select class="form-select"  v-model="commissioning_config.system_type">
                                                <option value="0">0: GRID CONNECTED ONLY</option>
                                                <option value="2">2: BACKUP POWER ENABLED</option>
                                            </select>
                                        </div>
                                        <div class="input-group input-group-sm mb-3">
                                            <div class="input-group-text" style="width: 150px;">CT ratio</div>
                                            <input type="text" class="form-control" v-model="commissioning_config.ct_ratio">
                                        </div>
                                        <div class="input-group input-group-sm mb-3">
                                            <div class="input-group-text" style="width: 150px;">BMS select</div>
                                            <select class="form-select"  v-model="commissioning_config.bms_select">
                                                <option value="0">0: NO BMS</option>
                                                <option value="1">1: INTERCEL</option>
                                                <option value="2">2: SOLUNA</option>
                                                <option value="3">3: CCP (250kbps)</option>
                                                <option value="4">4: CCP (500kbps)</option>
                                            </select>
                                        </div>
                                        <br/>
                                        <div class="form-check mb-3">
                                            <input class="form-check-input" type="checkbox" v-model="commissioning_config.update_firmware">
                                            <label class="form-check-label">Check and update firmware</label>
                                        </div>
                                        <div class="form-check mb-3" v-if="commissioning_config.update_firmware">
                                            <input class="form-check-input" type="checkbox" v-model="manual_firmware_version_input">
                                            <label class="form-check-label">Manual input</label>
                                        </div>
                                        <div class="input-group input-group-sm mb-3" v-if="commissioning_config.update_firmware">
                                            <div class="input-group-text" style="width: 150px;">ACSA firmware</div>
                                            <input v-if="manual_firmware_version_input" type="text" class="form-control" v-model="commissioning_config.acsa_target_firmware" />
                                            <select v-else v-model="commissioning_config.acsa_target_firmware" class="form-select">
                                                <option v-for="version in shared.firmware_versions['stardust.acs-autonomous']">{{ version }}</option>
                                            </select>
                                        </div>
                                        <div class="input-group input-group-sm mb-3" v-if="commissioning_config.update_firmware">
                                            <div class="input-group-text" style="width: 150px;">InREC firmware</div>
                                            <input v-if="manual_firmware_version_input" type="text" class="form-control" v-model="commissioning_config.inrec_target_firmware">
                                            <select v-else v-model="commissioning_config.inrec_target_firmware" class="form-select">
                                                <option v-for="version in shared.firmware_versions['inrec.firmware']">{{ version }}</option>
                                            </select>
                                        </div>
                                        <br/>
                                        <div class="form-check mb-3">
                                            <input class="form-check-input" type="checkbox" v-model="commissioning_config.acsa_to_factory_defaults">
                                            <label class="form-check-label">Set ACSA to factory default settings</label>
                                        </div>
                                        <div class="form-check mb-3">
                                            <input class="form-check-input" type="checkbox" v-model="commissioning_config.inrec_to_factory_defaults">
                                            <label class="form-check-label">Set InREC to factory default settings</label>
                                        </div>
                                    </div>
                                    <hr/>
                                    <div>
                                        <button type="button" class="btn btn-success btn-sm" style="margin-right: 10px;"
                                            @click="commissioningCommand('start')">
                                            Start
                                        </button>
                                        <button type="button" class="btn btn-info btn-sm" style="margin-right: 10px;"
                                            @click="commissioningCommand('proceed')">
                                            Proceed
                                        </button>
                                        <button type="button" class="btn btn-danger btn-sm" @click="commissioningCommand('abort')">
                                            Abort
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-6">    
                            <button type="button" class="btn btn-warning btn-sm float-end" @click="clearLog()">
                                Clear log
                            </button>
                            <h4 style="margin-top: 10px;">Log</h4>
                            <pre class="font-monospace bg-dark text-white" style="min-height: 300px; max-height: 800px; overflow-y: scroll;font-size: x-small;padding: 5px;">{{ hostDetail.log }}</pre>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- Host deletion confirmation modal -->
    <div class="modal fade" id="confirmHostDeletionModal" tabindex="-1" ref="confirmHostDeletionModal">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <h1 class="modal-title fs-5" id="exampleModalLabel">Are you sure?</h1>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="modal-body">
                    <h6>This will remove the following (retained) topics on the broker by publishing empty payloads</h6>
                    <code v-for="topic in hostDetail.received_topics">{{topic}}<br/></code>
                    <br/>
                    <h6>Note that these topics are republished when the host comes online again</h6>
                    <hr/>
                    <div class="alert alert-warning" role="alert">
                        Please reconnect to the broker after
                    </div>
                    <button type="button" class="btn btn-danger" @click="forgetHost()" data-bs-dismiss="modal">Forget host</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>


export default {
    props: ['hosts', 'client', 'received_topics', 'show_details_from_index'],
    setup() { },
    data() {
        return {
            hostDetail: {},
            hostDetailsIndex: -1,

            updated_config: {},

            commissioning_config: {
                "slave_count": 0,
                "system_type": 0,
                "ct_ratio": 100,
                "bms_select": 0,
                "power_fractions": [],
                "update_firmware": false,
                "acsa_target_firmware": null,
                "acsa_to_factory_defaults": false,
                "inrec_target_firmware": null,
                "inrec_to_factory_defaults": false,
            },
            manual_firmware_version_input: false,

            show_only_online: false,
        };
    },
    watch: { 
        hosts: {
            handler(val) {
                if (val.length == 0) {
                    // Reset config target
                    this.hostDetailsIndex = -1
                    this.hostDetail =  {}
                }
            },
            deep: true
        },
        show_details_from_index: function (newVal, oldVal) {
            this.showDetails(newVal)
        }
    },
    methods: {
        onJsonChange (value) {
            this.updated_config = value
        },
        showDetails(index) {
            this.hostDetailsIndex = index
            if (index >= 0 && index < this.hosts.length) {
                this.hostDetail = this.hosts[index]

                // Filter all topics from this host
                this.hostDetail.received_topics = this.received_topics.filter(str => str.includes("reconvert/" + this.hostDetail.hostname));
            } else {
                this.hostDetail = {}
            }
        },
        readHostConfig() {
            var topic = "reconvert/" + this.hostDetail.hostname + "/request"
            var payload = {
                function: "read_config",
                target: "client",
            }
            this.hostDetail.config = {}
            //console.log({ topic: topic, payload: payload })
            this.client.publish(topic, JSON.stringify(payload), error => {
                if (error) {
                    console.log('Publish error', error)
                }
            })
        },
        updateHostConfig() {
            try {
                var topic = "reconvert/" + this.hostDetail.hostname + "/request"
                var payload = {
                    function: "update_config",
                    target: "client",
                    config: this.updated_config
                }
                //console.log({ topic: topic, payload: payload })
                this.client.publish(topic, JSON.stringify(payload), error => {
                    if (error) {
                        console.log('Publish error', error)
                    }
                })
            } catch ({ name, message }) {
                console.error(name);
                console.error(message);
            }
        },
        restartHost() {
            var topic = "reconvert/" + this.hostDetail.hostname + "/request"
            var payload = {
                function: "software_reset",
                target: "client",
            }
            //console.log({ topic: topic, payload: payload })
            this.client.publish(topic, JSON.stringify(payload), error => {
                if (error) {
                    console.log('Publish error', error)
                }
            })
        },
        forgetHost() {
            for (const topic of this.hostDetail.received_topics) {
                this.client.publish(topic, null, { qos: 0, retain: true }, error => {
                    if (error) {
                        console.log('Publish error', error)
                    }
                })
            }

            console.log("Forgetting host ", "reconvert/" + this.hostDetail.hostname)
        },
        clearLog() {
            try {
                var topic = "reconvert/" + this.hostDetail.hostname + "/request"
                var payload = {
                    function: "clear_log",
                    target: "client",
                    config: this.updated_config
                }
                //console.log({ topic: topic, payload: payload })
                this.client.publish(topic, JSON.stringify(payload), error => {
                    if (error) {
                        console.log('Publish error', error)
                    }
                })
            } catch ({ name, message }) {
                console.error(name);
                console.error(message);
            }
        },

        commissioningCommand(command) {
            var topic = "reconvert/" + this.hostDetail.hostname + "/request"
            var payload = {}
            if (command == 'start') {
                payload = {
                    function: "cluster_update_and_commissioning",
                    target: "client",
                    command: command,
                    config: this.commissioning_config
                }
            } else {
                payload = {
                    function: "cluster_update_and_commissioning",
                    target: "client",
                    command: command,
                }
            }
            

            this.client.publish(topic, JSON.stringify(payload), error => {
                if (error) {
                    console.log('Publish error', error)
                }
            })
        }
    },
    created() {

    },
};
</script>